function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, React.createElement("circle", {
  fill: "#F2C12E",
  cx: 13,
  cy: 13,
  r: 13
}), React.createElement("path", {
  d: "M10.803 13.354a4 4 0 114.367-.003c2.242.716 3.83 2.508 3.83 4.604 0 2.728-12.016 2.728-12.016 0 0-2.093 1.584-3.882 3.82-4.601z",
  fill: "#FFF"
}));

var SvgAccount = function SvgAccount(props) {
  return React.createElement("svg", _extends({
    width: 26,
    height: 26
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMjYgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU1LjEgKDc4MTM2KSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5Hcm91cDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJHcm91cCIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbCIgZmlsbD0iI0YyQzEyRSIgY3g9IjEzIiBjeT0iMTMiIHI9IjEzIj48L2NpcmNsZT4KICAgICAgICAgICAgPHBhdGggZD0iTTEwLjgwMzQwNiwxMy4zNTM2Njk2IEM5LjcwODMwOTQ5LDEyLjY0MDA0NTQgOC45ODQzNzUsMTEuNDA0NTY0NyA4Ljk4NDM3NSwxMCBDOC45ODQzNzUsNy43OTA4NjEgMTAuNzc1MjM2LDYgMTIuOTg0Mzc1LDYgQzE1LjE5MzUxNCw2IDE2Ljk4NDM3NSw3Ljc5MDg2MSAxNi45ODQzNzUsMTAgQzE2Ljk4NDM3NSwxMS40MDIzNjE5IDE2LjI2MjcwOTQsMTIuNjM2MTY5NyAxNS4xNzA0OTM2LDEzLjM1MDMwODIgQzE3LjQxMTY3NzYsMTQuMDY3NDY5OCAxOSwxNS44NTg3MTkyIDE5LDE3Ljk1NDk2NDggQzE5LDIwLjY4Mjg4NjkgNi45ODQzNzUsMjAuNjgyODg2OSA2Ljk4NDM3NSwxNy45NTQ5NjQ4IEM2Ljk4NDM3NSwxNS44NjE5ODY3IDguNTY3NzQ5NzUsMTQuMDczMDU0NyAxMC44MDM0MDYsMTMuMzUzNjY5NiBMMTAuODAzNDA2LDEzLjM1MzY2OTYgWiIgaWQ9InBhdGgtMSIgZmlsbD0iI0ZGRkZGRiI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgAccount as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./src/components/lib/Icons/SystemIcon/svg/account.svg
// module id = 909
// module chunks = 0